export default {"src":"/_next/static/media/approval.5e164b69.svg","height":89,"width":84};